import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import LanguageSwitcher from './LanguageSwitcher';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const { isLoading } = useAuth();
  const { t } = useTranslation();

  const handleGoogleLogin = () => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
    const backendUrl = apiUrl.replace('/api', '');
    window.location.href = `${backendUrl}/auth/google`;
  };

  if (isLoading) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="loading">{t('common:loading')}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-header">
        <LanguageSwitcher />
      </div>
      <div className="login-container">
        <h1>{t('common:appName')}</h1>
        <p>{t('auth:loginMessage')}</p>
        <button 
          className="google-login-btn"
          onClick={handleGoogleLogin}
        >
          <img 
            src="https://developers.google.com/identity/images/g-logo.png" 
            alt="Google"
            className="google-icon"
          />
          {t('auth:loginWithGoogle')}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;